<template>
  <div id="app">
    <Header style="z-index: 2000" />
    <router-view
      v-if="isRouterAlive"
      :style="{ minHeight: minHeight + 'px' }"
    />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/pc/Footer/Footer.vue";
import Header from "@/components/pc/Header/Header.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      minHeight: 0,
      isRouterAlive: true
    };
  },
  mounted() {
    this.minHeight = document.documentElement.clientHeight - 516;
    let that = this;
    window.onresize = function() {
      that.minHeight = document.documentElement.clientHeight - 516;
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="less">
@import "~@/assets/style/variables.less";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  // 自定义pagination
  .el-pagination.is-background {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-prev,
    .btn-next {
      width: 72px;
      height: 36px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(228, 228, 228, 1);
      border-radius: 2px 0px 0px 2px;
    }

    .el-pager {
      .number {
        width: 36px;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(228, 228, 228, 1);
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 36px;
      }

      .number.active {
        background: @bgColor;
        color: #fff;
      }
    }

    .el-pagination__jump {
      min-width: 50px;
      height: 36px;
      line-height: 36px;

      .el-input {
        width: 72px;
        height: 36px;
        margin: 0 10px;

        input {
          width: 72px;
          height: 36px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(228, 228, 228, 1);
          border-radius: 2px;
        }
      }
    }
  }
}
</style>
